module.exports = __webpack_public_path__ + "static/media/carefolio_logo_WHITE.b7a2d5e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/svg/carefolio_logo_WHITE.svg
// module id = 229
// module chunks = 0